<template>
    <div>
        <template v-if="manage_meta_data == true">
            <div class="page-top mb-1 mb-3">
                <h1> Add MetaData </h1>
            </div>
            <div class="global-main">
                <form id="onboardingDocumentForm" @submit.prevent="addMetaDataDocument" novalidate>
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label>Key <em class="required">*</em></label>
                            <input v-model="form.key" type="text" name="key" class="form-control" :class="{ 'is-invalid': form.errors.has('key') }" maxlength="120">
                            <has-error :form="form" field="key"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Value <em class="required">*</em></label>
                            <input v-model="form.value" type="text" name="document_title" class="form-control" :class="{ 'is-invalid': form.errors.has('value') }" maxlength="50">
                            <has-error :form="form" field="value"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Comment  <em class="required">*</em></label>
                            <input v-model="form.comment" type="text" name="comment" class="form-control" :class="{ 'is-invalid': form.errors.has('comment') }" maxlength="150">
                            <has-error :form="form" field="comment"></has-error>
                        </div>

                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/manageMetaDataComponent" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="manage_meta_data === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="manage_meta_data === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form: new Form({
                    key: "",
                    value: "",
                    comment: "",
                }),
                manage_meta_data: null
            };
        },
        methods: {
            addMetaDataDocument() {
                let newForm= new FormData()
                $.each(this.form, (key, value) => {
                    if (key !== 'busy' && key !== 'successful' && key !== 'errors' &&   key !== 'originalData') {
                        newForm.append(key, value);
                    }
                });
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                axios.post('/api/addEditMetaData',newForm, config)
                .then(res => {
                    if(res.data.code == 200){
                        if(res.data.code == '200'){
                            this.showToastBox("success", "The records have been successfully added");
                            this.$router.push("/manageMetaDataComponent");
                        }else{
                            var error_msg = '';
                            error_msg = 'Please provide following details:'+'\n';     
                            $.each(res.data.data, (key, value) => {
                                error_msg += value +'\n';     
                            });
                            this.showAlertBox('error',error_msg);
                        }
                    }else{
                        this.showAlertBox('error','Some problem in your form data');
                    }
                }).then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                    .catch(errors => {
                        const errorMessages = Object.entries(errors.response.data.errors)
                            .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
                            .join('\n');
                        this.showAlertBox('error', `Validation errors:\n${errorMessages}`);
                    });
            },
        },
        mounted() {
            this.can("manage_meta_data")
                .then((result) => {
                    this.manage_meta_data = result.manage_meta_data;
                })
                .then((result) => {
                    if (this.manage_meta_data == true) {
                        $('#sample_file_div').hide();
                        this.$Progress.finish();
                    } else {
                        this.$Progress.finish();
                    }
                });
        },
    }
</script>
